"use client"

import { useEffect, useState } from "react"
import { useSearchParams } from "next/navigation"

import { ReducedProductData } from "@/lib/storefront/product/product"
import { trackGTMAndFF } from "@/lib/tracking/tracking-helper"

/*The purpose of this */
export default function FFProductClickTrackingClient(props: {
  trackingList?: string
  productData: ReducedProductData
  position: number
  page?: number
  pageSize?: number
  searchTerm?: string
  trackingMarker: string
}) {
  const [tracked, setTracked] = useState(false)

  const searchParams = useSearchParams()

  useEffect(() => {
    function trackingHandler() {
      trackGTMAndFF(props, searchParams)
      setTracked(true)
    }

    //console.log("Running tracking event listener attach")
    if (props.trackingList !== undefined) {
      if (!tracked) {
        const element = document.querySelector('[data-tracking-marker="' + props.trackingMarker + '"]')
        if (element) {
          // console.info("Tracking element found")
          element.addEventListener("click", trackingHandler)
        } else {
          // console.info("Tracking element isn't found -> not connecting tracking event")
        }
      } else {
        //console.info("already tracked")
      }
    } else {
      console.info("trackingList not found -> not connecting tracking event")
    }
    return () => {
      const element = document.querySelector('[data-tracking-marker="' + props.trackingMarker + '"]')
      if (element) {
        element.removeEventListener("click", trackingHandler)
      }
    }
  }, [props.page, props.pageSize, props.position, props.productData, props.trackingList, props.trackingMarker, tracked])

  return (
    <>
      <span className={"prdclk hidden"}>{props.trackingMarker}</span>
    </>
  )
}
